import React, { useMemo } from "react";
import { Button } from "../components/Form";
import { useNavigate } from "react-router-dom";

function NotFound() {
  const navigate = useNavigate();

  const sentences = [
    { text: "Looks like this page took a wrong turn" },
    { text: "We couldn’t find what you’re looking for" },
    { text: "This page is hiding somewhere else" },
    { text: "Lost in the Lokalai universe" },
    { text: "The page you seek isn’t here" },
    { text: "Oops… this path leads nowhere" },
    { text: "Seems like this page missed the memo" },
    { text: "The link may be out of date" },
    { text: "Looks like we hit a dead end" },
    { text: "This page is taking a little vacation" },
    { text: "Nothing to see here… yet" },
    { text: "404: Adventure ends here" },
  ];

  const randomSentence = useMemo(
    () => sentences[Math.floor(Math.random() * sentences.length)],
    []
  );

  return (
    <div className="w-full h-screen flex-colo bg-dry text-center p-8 gap-y-6">
      {/* Animated marker */}
      <div className="relative mb-0 animate-updown">
        <div className="h-[100px] w-[100px] border-[6px] border-redlight rotate-45 rounded-[50%_50%_0%_50%] relative mb-8 shadow-redlight/20 shadow-xl">
          <div className="absolute h-[60%] w-[60%] rounded-full border-[8px] border-transparent border-t-redlight border-b-redlight top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 animate-rotate" />
          <div className="absolute top-1/2 left-1/2 w-12 h-12 bg-dry rounded-full animate-glowPulse" />
          <div className="absolute top-[35px] left-[35px] w-[20px] h-[20px] bg-[#ff0000] rounded-full" />
        </div>

        {/* Foot arc */}
        <svg
          className="absolute bottom-[-15px] left-1/2 transform -translate-x-1/2"
          width="40"
          height="40"
          viewBox="0 0 120 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M0 40 Q60 -20 120 40 Q60 10 0 40 Z" fill="#f87171" />
        </svg>
      </div>

      <h1 className="text-4xl font-bold mt-10 text-redlight">Page Not Found</h1>
      <p className="text-lg text-textGray my-3">{randomSentence.text} </p>

      {/* Loader dots */}

      {/* Back button */}
      <div className="w-48 mx-auto">
        <Button
          label={"Back to Home"}
          Icon={null}
          onClick={() => navigate("/")}
        />{" "}
        <div className="loader-dots animate-dotBounce mx-auto my-6"></div>
      </div>
    </div>
  );
}

export default NotFound;
